export enum ModuleType {

    // NEVER CHJANGE VALUES HERE !!!! because they are used in company.settings.modulesConfig as keys !!!
    // do not use dash - same as gd.modules.XXX name

    REQUESTS                = 'requests',
    PUBLIC_FORMS            = 'publicForms',
    SHARED_VIEWS            = 'sharedViews',
    EXPENSES                = 'expenses',
    LABOR_COST              = 'labor-cost',
    INVOICES                = 'invoices',
    TWO_FA                  = 'twoFA',
    EMAIL_TEMPLATES         = 'emailTemplates',
    EMAIL_CREATE_TASK       = 'emailCreateTask',
    EVENTS                  = 'events',
    TAGS                    = 'tags',
    PAGES                   = 'pages',
    PUBLIC_SHARING          = 'publicSharing',
    PORTFOLIO               = 'portfolio',
    REPORTS_ANALYTICS       = 'reports-analytics',
    ATTACHMENTS             = 'attachments',
    AUTOMATIONS             = 'automations',
    GOALS                   = 'goals',
    DASHBOARDS              = 'dashboards',
    REMINDERS               = 'reminders',
    MEETINGS                = 'meetings',
    STORY_POINTS            = 'storyPoints',
    DOCUMENTS               = 'documents',
    NOTEPAD                 = 'notepad',
    CHATS                   = 'chats',
    TIME_TRACKING           = 'timeTracking',
    WORKLOAD                = 'workload',
    CLOCK_IN_OUT            = 'clockInOut',
    GUESSTIMATE             = 'guesstimate',
    CRM_ACCOUNT             = 'crmAccount',
    CRM_CONTACT             = 'crmContact',
    CRM                     = 'crm',
    CUSTOMER_PORTAL         = 'customerPortal',
    GD_LABS                 = 'gdLabs',
    OFFICES                 = 'offices',
    CUSTOM_ENTITIES         = 'customEntities',
    DEPENDENCIES            = 'dependencies',
    VALIDATIONS             = 'validations',
    SUPPORT_TICKET          = 'supportTicket',

    VIEW_LIST               = 'viewList',
    VIEW_TABLE              = 'viewTable',
    VIEW_BOARD              = 'viewBoard',
    VIEW_CALENDAR           = 'viewCalendar',
    VIEW_EVENTS_SUMMARY     = 'viewEventsSummary',
    VIEW_GANTT              = 'viewGantt',
    VIEW_WORKLOAD           = 'viewWorkload',
    VIEW_TIMELINE           = 'viewTimeline',
    VIEW_MY_TIME            = 'viewMyTime',
    VIEW_MY_CALENDAR        = 'viewMyCalendar',
    VIEW_MY_TASKS           = 'viewMyTasks',
    VIEW_MY_WORKLOAD        = 'viewMyWorkload',
    VIEW_MY_MEETINGS        = 'viewMyMeetings',
    VIEW_MY_DOCUMENTS       = 'viewMyDocuments',
    VIEW_WHATS_DONE         = 'viewWhatsDone',
    VIEW_PAST_DUE           = 'viewPastDue',
    VIEW_PRIORITIES         = 'viewPriorities',
    VIEW_ACTION_REQUIRED    = 'viewActionRequired',
    VIEW_TASK_BY_USER       = 'viewTaskByUser',
    VIEW_DASHBOARD          = 'viewDashboard',
    VIEW_RECENT             = 'viewRecent',
    VIEW_ACTIVITY_STREAM    = 'viewActivityStream',
    VIEW_PORTFOLIO_SUMMARY  = 'viewPortfolioSummary',
    VIEW_PROJECTS_LIST      = 'viewProjectsList',


    REACTIONS               = 'reactions',


    GOOGLE_DRIVE            = 'googleDrive',
    GOOGLE_CALENDAR         = 'googleCalendar',
    OUTLOOK_CALENDAR        = 'outlookCalendar',
    GOOGLE_SUITE            = 'googleSuite',
    EMAIL                   = 'email',
    GITHUB                  = 'github',
    GITLAB                  = 'gitlab',
    SLACK                   = 'slack',

    DROPBOX                 = 'dropbox',
    SSO_GOOGLE              = 'ssoGoogle',
    SSO_MICROSOFT           = 'ssoMicrosoft',
    MICROSOFT_ENTRA_ID      = 'microsoftEntraId',
    SAML                    = 'saml',
    TASK_VIA_EMAIL          = 'taskViaEmail',
    EMAIL_REPLY             = 'emailReply',
    REPLY_TASK_BY_EMAIL     = 'replyTaskByEmail',

}
